import { createTheme } from '@mui/material';
import darkScrollbar from '@mui/material/darkScrollbar';
import palette from './styles/palette';

const theme = createTheme({
  palette: {
    primary: {
      light: palette.gt_lemon_2,
      main: palette.gt_green_6,
      dark: palette.gt_green_6,
      contrastText: palette.gt_text_primary,
    },
    secondary: {
      light: palette.gt_grey_light_3,
      main: palette.gt_grey_light_3,
      dark: palette.gt_grey_light_3,
      contrastText: palette.gt_text_secondary,
    },
  },
  typography: {
    fontFamily: ['Avenir', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
  },
});

theme.components = {
  MuiCssBaseline: {
    styleOverrides: (themeParam) => ({
      body: themeParam.palette.mode === 'dark' ? darkScrollbar() : null,
    }),
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        background: palette.dark_blue,
        color: palette.gt_grey_light_2,
      },
    },
  },
  MuiDivider: {
    styleOverrides: {
      root: {
        marginTop: '2em',
        marginBottom: '1em',
        color: palette.gt_teal_8,
      },
    },
  },
  MuiButton: {
    disableElevation: true,
    styleOverrides: {
      root: {
        borderRadius: 0,
        textTransform: 'none',
        fontFamily: ['Poppins', 'Arial', 'sans-serif'].join(','),
        fontSize: '1.2rem',
        fontWeight: 700,
        marginTop: '1em',
        marginBottom: '2em',
        padding: '0.7em',
        paddingLeft: '1.5em',
        paddingRight: '1.5em',
      },
      containedPrimary: {
        '&:hover': {
          color: '#000',
          boxShadow: `5px 3px 3px ${palette.gt_grey_light_6}`,
        },
      },
      containedSecondary: {
        backgroundColor: `${palette.gt_grey_light_3}`,
        color: `${palette.gt_text_disabled}`,
        border: `1px solid ${palette.gt_grey_light_5}`,
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        fontFamily: ['Lato', 'Arial', 'sans-serif'].join(','),
        fontSize: '1.2em',
        color: `${theme.palette.primary.contrastText}`,
        '&.Mui-focused': {
          color: `${theme.palette.primary.contrastText}`,
          fontWeight: '600',
        },
      },
      focused: {},
    },
  },
  MuiInput: {
    styleOverrides: {
      root: {
        top: theme.spacing(2),
        padding: theme.spacing(1.5),
        backgroundColor: palette.white,
        color: `${palette.gt_text_primary}`,
        fontFamily: ['Lato', 'Arial', 'sans-serif'].join(','),
        borderRadius: '4px',
        border: `1px solid ${palette.gt_grey_light_5}`,
        outline: `1px solid transparent`,
      },
      danger: {
        border: `1px solid ${theme.palette.red}`,
      },
    },
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        fontFamily: ['Lato', 'Arial', 'sans-serif'].join(','),
        fontSize: '0.8em',
        marginTop: '1.2em',
      },
    },
  },
  MuiSelect: {
    styleOverrides: {
      root: {
        top: theme.spacing(2),
        backgroundColor: palette.white,
        borderRadius: '4px',
        fontFamily: ['Lato', 'Arial', 'sans-serif'].join(','),
        color: `${theme.palette.primary.contrastText}`,
        border: `1px solid ${palette.gt_grey_light_5}`,
        outline: `1px solid transparent`,
      },
      danger: {
        border: `1px solid ${theme.palette.red}`,
      },
    },
  },
  MuiAutocomplete: {
    styleOverrides: {
      root: {
        top: theme.spacing(2),
        marginBottom: '1em',
        backgroundColor: palette.white,
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 0,
        textTransform: 'none',
        fontSize: '1.1rem',
        fontWeight: 700,
        marginTop: '2rem',
        marginBottom: '2rem',
      },
    },
  },
};

export default theme;
